var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorarrowleftActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26672 1.10636C6.92427 0.51287 5.88315 -0.426818 5.22561 0.216126L0.403603 4.51891C0.129626 4.7662 0.129626 5.21131 0.403603 5.4586L5.22561 9.81084C5.88315 10.4043 6.92427 9.46464 6.26672 8.87115L1.99267 5.01348L6.26672 1.10636Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorarrowleftActive);
export default __webpack_public_path__ + "static/media/Vectorarrowleft_active.651615e452f09ff17d32bba54da7f4d4.svg";
export { ForwardRef as ReactComponent };